import React from 'react';
import Popover from 'react-bootstrap/lib/Popover';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Button from 'react-bootstrap/lib/Button';
import Info from 'react-icons/lib/fa/info-circle'

const popoverRight = (text) => (
  <Popover id="popover-positioned-right">
    {text}
  </Popover>
);

const InfoPopOver = (props) => (
<div className='popover-container'>
  <OverlayTrigger trigger="click" rootClose placement="right" overlay={popoverRight(props.popOverText)}>
    <button type="button" onClick={(e) => e.stopPropagation()} className="info-button"><Info /> </button>
  </OverlayTrigger>
</div>
);

InfoPopOver.propTypes = {  
};

export default InfoPopOver;
